const $ = jQuery;
import flatpickr from "flatpickr";
import { Ukrainian } from "flatpickr/dist/l10n/uk.js";

// Встановлюємо локалізацію глобально
flatpickr.localize(Ukrainian);

let isLoading = false;

function applyGlobalValidationMessagesUA() {
    if (!$.validator) return false;

    if (!$.validator.methods.phoneUA) {
        $.validator.addMethod("phoneUA", function(value, element) {
            const isComplete = value.replace(/_/g, "").length === 13;
            return this.optional(element) || isComplete;
        }, "Введіть повний номер телефону.");
    }

    const fieldMessages = {
        required: "Це поле обовʼязкове.",
        remote: "Будь ласка, виправте це поле.",

        email: "Введіть коректну email адресу.",
        url: "Введіть коректне посилання (URL).",
        date: "Введіть коректну дату.",
        dateISO: "Введіть коректну дату (ISO).",
        number: "Введіть коректне число.",
        digits: "Введіть лише цифри.",
        creditcard: "Введіть коректний номер картки.",

        minlength: "Введіть щонайменше {0} символів.",
        maxlength: "Введіть не більше {0} символів.",
        rangelength: "Введіть значення довжиною від {0} до {1} символів.",

        min: "Введіть значення не менше {0}.",
        max: "Введіть значення не більше {0}.",
        range: "Введіть значення в діапазоні від {0} до {1}.",

        equalTo: "Будь ласка, введіть те саме значення ще раз.",
        accept: "Будь ласка, виберіть файл з дозволеним розширенням.",
        extension: "Будь ласка, виберіть файл з дозволеним розширенням.",
        pattern: "Будь ласка, дотримуйтесь потрібного формату.",
        phoneUA: "Введіть повний номер телефону."
    };

    $.extend($.validator.messages, fieldMessages);

    $.validator.defaults = $.validator.defaults || {};
    $.validator.defaults.messages = $.validator.defaults.messages || {};
    $.extend($.validator.defaults.messages, fieldMessages);

    return true;
}

function bindValidationToPhone() {
    $('input[name="phone"]').each(function() {
        const $el = $(this);
        const $form = $el.closest('form');

        if (!$form.data("validator")) {
            $form.validate();
        }

        $el.rules("add", {
            phoneUA: true
        });
    });
}

function applyPhoneMaskE164(root = document) {
    const $phones = $(root).find('input[name="phone"]');
    if (!$phones.length) return;

    if (typeof $.fn.inputmask !== 'function') return;

    $phones.each(function () {
        const $phone = $(this);

        if ($phone.data('phone-mask-ready')) {
            return;
        }

        $phone.inputmask({
            mask: "+380999999999",
            showMaskOnHover: false,
            showMaskOnFocus: true,
            clearIncomplete: false,
            onBeforeMask: function (value) {
                return value || "";
            }
        });

        $phone
            .off('blur.phoneMask')
            .on('blur.phoneMask', function () {
                const $form = $(this).closest('form');

                if ($form.data('validator')) {
                    $(this).valid();
                }
            });

        $phone.data('phone-mask-ready', true);
    });
}

function applyDateOfBirthPicker(root = document) {
    const $dateFields = $(root).find('input[name="date-of-birth"]');
    if (!$dateFields.length) return;

    $dateFields.each(function () {
        const $el = $(this);

        if ($el.data('dob-picker-ready')) {
            return;
        }

        const picker = flatpickr(this, {
            locale: Ukrainian,
            dateFormat: "d.m.Y",
            maxDate: "today",
            allowInput: true,
            clickOpens: false,
            monthSelectorType: "dropdown",
            disableMobile: true,
            onChange: function (selectedDates, dateStr, instance) {
                $(instance.element).valid();
            },
            onClose: function (selectedDates, dateStr, instance) {
                $(instance.element).valid();
            }
        });

        $el.on('input.dobPicker', function () {
            let value = $(this).val();

            value = value.replace(/[^\d.]/g, '');
            value = value.replace(/\.{2,}/g, '.');

            const digits = value.replace(/\D/g, '').slice(0, 8);

            let formatted = '';

            if (digits.length > 0) {
                formatted += digits.substring(0, 2);
            }

            if (digits.length >= 3) {
                formatted += '.' + digits.substring(2, 4);
            }

            if (digits.length >= 5) {
                formatted += '.' + digits.substring(4, 8);
            }

            $(this).val(formatted);
        });

        $el.on('blur.dobPicker', function () {
            const value = $(this).val();

            if (/^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
                picker.setDate(value, false, "d.m.Y");
            } else {
                picker.clear();
            }

            $(this).valid();
        });

        $el.on('keydown.dobPicker', function (e) {
            const allowedKeys = [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ];

            if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
                return;
            }

            if (!/^\d$/.test(e.key) && e.key !== '.') {
                e.preventDefault();
            }
        });

        $el.closest('.date-field-wrap').find('.js-open-calendar').off('click.dobPicker').on('click.dobPicker', function (e) {
            e.preventDefault();
            e.stopPropagation();
            picker.open();
        });

        $el.data('dob-picker-ready', true);
    });
}

function bindSubmitProtection() {
    $(document)
        .off('submit.submitProtection', '.wpcf7 form')
        .on('submit.submitProtection', '.wpcf7 form', function (e) {
            const $form = $(this);
            const $submit = $form.find('button[type="submit"], input[type="submit"]').first();

            if (isLoading) {
                e.preventDefault();
                return false;
            }

            isLoading = true;

            $submit.prop('disabled', true);
            $form.addClass('is-loading');
        });

    document.addEventListener('wpcf7invalid', function (e) {
        const $form = $(e.target);
        const $submit = $form.find('button[type="submit"], input[type="submit"]').first();

        isLoading = false;
        $submit.prop('disabled', false);
        $form.removeClass('is-loading');
    }, false);

    document.addEventListener('wpcf7mailfailed', function (e) {
        const $form = $(e.target);
        const $submit = $form.find('button[type="submit"], input[type="submit"]').first();

        isLoading = false;
        $submit.prop('disabled', false);
        $form.removeClass('is-loading');
    }, false);

    document.addEventListener('wpcf7spam', function (e) {
        const $form = $(e.target);
        const $submit = $form.find('button[type="submit"], input[type="submit"]').first();

        isLoading = false;
        $submit.prop('disabled', false);
        $form.removeClass('is-loading');
    }, false);

    document.addEventListener('wpcf7mailsent', function (e) {
        const $form = $(e.target);
        const $submit = $form.find('button[type="submit"], input[type="submit"]').first();

        isLoading = false;
        $submit.prop('disabled', false);
        $form.removeClass('is-loading');
    }, false);

    document.addEventListener('wpcf7submit', function (e) {
        const $form = $(e.target);
        const $submit = $form.find('button[type="submit"], input[type="submit"]').first();

        isLoading = false;
        $submit.prop('disabled', false);
        $form.removeClass('is-loading');
    }, false);
}

$(function () {
    let checkValidator = setInterval(() => {
        if ($.validator) {
            applyGlobalValidationMessagesUA();
            bindValidationToPhone();
            clearInterval(checkValidator);
        }
    }, 100);

    applyPhoneMaskE164(document);
    applyDateOfBirthPicker(document);
    bindSubmitProtection();

    document.addEventListener('wpcf7init', () => {
        applyPhoneMaskE164(document);
        applyDateOfBirthPicker(document);
        bindValidationToPhone();
    }, false);

    document.addEventListener('wpcf7invalid', (e) => {
        applyPhoneMaskE164(e.target);
        applyDateOfBirthPicker(e.target);
        bindValidationToPhone();
    }, false);
});